/**
 * How this person's address box offers a street's numbers: in the list, the street found
 * alone with its first numbers under it — the default — or after the street, picked first and
 * its number chosen from the whole list. Their own choice from the person menu.
 *
 * Apart from `NumbersSelect` for the reason `preferencesContext.ts` gives: a module that
 * exports a component and a hook cannot be fast-refreshed.
 */

import { usePreferences } from './preferencesContext';

/** How a street's numbers are offered. */
export type NumberWay = 'list' | 'after';

/** The way this person's address box offers a street's numbers. */
export function useNumberWay(): NumberWay {
  return usePreferences().current.numbers ?? 'list';
}
